export default __webpack_public_path__ + "static/media/dolphins.17e254e4.svg";